import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storage: window.localStorage,
    storageKey: 'supabase.auth.token',
  },
  global: {
    headers: {
      'X-Client-Info': 'supabase-js-web',
    },
  },
});

// Manejar errores de red en las solicitudes de autenticación
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'TOKEN_REFRESHED') {
    console.log('Token renovado exitosamente');
  } else if (event === 'SIGNED_OUT') {
    console.log('Sesión cerrada');
  } else if (event === 'USER_UPDATED') {
    console.log('Usuario actualizado');
  }
});

// Types
export interface Baby {
  id: string;
  user_id: string;
  name: string;
  birth_date: string;
  gender: 'male' | 'female';
  birth_weight?: number;
  birth_height?: number;
  photo_url?: string;
  created_at: string;
  updated_at: string;
}

export interface FeedingRecord {
  id: string;
  baby_id: string;
  type: 'breast' | 'bottle' | 'solid';
  start_time: string;
  end_time?: string;
  amount?: number;
  breast_side?: 'left' | 'right' | 'both';
  food_type?: string;
  notes?: string;
  created_at: string;
}

export interface SleepRecord {
  id: string;
  baby_id: string;
  start_time: string;
  end_time?: string;
  quality?: 'excellent' | 'good' | 'fair' | 'poor';
  location?: string;
  notes?: string;
  created_at: string;
}

export interface DiaperRecord {
  id: string;
  baby_id: string;
  type: 'wet' | 'dirty' | 'mixed';
  time: string;
  notes?: string;
  created_at: string;
}

export interface GrowthRecord {
  id: string;
  baby_id: string;
  weight?: number;
  height?: number;
  weight_percentile?: number;
  height_percentile?: number;
  recorded_at: string;
  created_at: string;
}

export interface Milestone {
  id: string;
  baby_id: string;
  category: 'motor' | 'cognitive' | 'social' | 'language';
  milestone: string;
  achieved: boolean;
  achieved_at?: string;
  age_range_start?: number;
  age_range_end?: number;
  notes?: string;
  created_at: string;
}
